import Immutable from "seamless-immutable";
import {
  GET_DDA_POLICY,
  GET_DDA_POLICY_SUCCESS,
  GET_DDA_POLICY_FAILURE,
  CREATE_EDDA,
  CREATE_EDDA_SUCCESS,
  CREATE_EDDA_FAILURE,
  GET_GIRO_BANK_LIST,
  GET_GIRO_BANK_LIST_SUCCESS,
  GET_GIRO_BANK_LIST_FAILURE,
  GET_GIRO_CALL_BACK_DATA,
  GET_GIRO_CALL_BACK_DATA_SUCCESS,
  GET_GIRO_CALL_BACK_DATA_FAILURE,
  SUBMIT_GIRO_DATA,
  SUBMIT_GIRO_SUCCESS,
  SUBMIT_GIRO_FAILURE,
  GET_GIRO_CALL_BACK_EXIST,
  GET_GIRO_CALL_BACK_EXIST_SUCCESS,
  GET_GIRO_CALL_BACK_EXIST_FAILURE,
  GET_GIRO_SUBMIT_CALL_BACK_EXIST,
  GET_GIRO_SUBMIT_CALL_BACK_EXIST_SUCCESS,
  GET_GIRO_SUBMIT_CALL_BACK_EXIST_FAILURE,
  ENROL_EGIRO,
  ENROL_EGIRO_SUCCESS,
  ENROL_EGIRO_FAILURE,
  CONFIRM_PAY_EDDA_GI_RENEWAL,
  CONFIRM_PAY_EDDA_GI_RENEWAL_SUCCESS,
  CONFIRM_PAY_EDDA_GI_RENEWAL_FAILURE
} from "../actions/enrolGIRONow";

const INITIAL_STATE = Immutable({
  getDDAPolicy: null,
  createEDDA: null,
  getGIROBankList: null,
  getGIROCallBackData: null,
  getGIROCallBackExist: null,
  submitGiro: null,
  getGIROSubmitCallBackExist: null,
  enroleGiro:null,
  confirmPayEddaGiRenewal:null,
});

function enrolGIRONow(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_DDA_POLICY:
      return state
        .setIn(["getDDAPolicy", "loading"], true)
        .setIn(["getDDAPolicy", "status"], false);
    case GET_DDA_POLICY_SUCCESS:
      return state
        .setIn(["getDDAPolicy", "loading"], false)
        .setIn(["getDDAPolicy", "items"], action.data)
        .setIn(["getDDAPolicy", "status"], true);
    case GET_DDA_POLICY_FAILURE:
      return state
        .setIn(["getDDAPolicy", "loading"], false)
        .setIn(["getDDAPolicy", "status"], false);
    case CREATE_EDDA:
      return state
        .setIn(["createEDDA", "loading"], true)
        .setIn(["createEDDA", "status"], false);
    case CREATE_EDDA_SUCCESS:
      return state
        .setIn(["createEDDA", "loading"], false)
        .setIn(["createEDDA", "items"], action.data)
        .setIn(["createEDDA", "status"], true);
    case CREATE_EDDA_FAILURE:
      return state
        .setIn(["createEDDA", "loading"], false)
        .setIn(["createEDDA", "status"], false);
    case GET_GIRO_BANK_LIST:
      return state
        .setIn(["getGIROBankList", "loading"], true)
        .setIn(["getGIROBankList", "status"], false);
    case GET_GIRO_BANK_LIST_SUCCESS:
      return state
        .setIn(["getGIROBankList", "loading"], false)
        .setIn(["getGIROBankList", "items"], action.data)
        .setIn(["getGIROBankList", "status"], true);
    case GET_GIRO_BANK_LIST_FAILURE:
      return state
        .setIn(["getGIROBankList", "loading"], false)
        .setIn(["getGIROBankList", "status"], false);
    case GET_GIRO_CALL_BACK_DATA:
      return state
        .setIn(["getGIROCallBackData", "loading"], true)
        .setIn(["getGIROCallBackData", "status"], false);
    case GET_GIRO_CALL_BACK_DATA_SUCCESS:
      return state
        .setIn(["getGIROCallBackData", "loading"], false)
        .setIn(["getGIROCallBackData", "items"], action.data)
        .setIn(["getGIROCallBackData", "status"], true);
    case GET_GIRO_CALL_BACK_DATA_FAILURE:
      return state
        .setIn(["getGIROCallBackData", "loading"], false)
        .setIn(["getGIROCallBackData", "status"], false);
    case SUBMIT_GIRO_DATA:
      return state
        .setIn(["submitGiro", "loading"], true)
        .setIn(["submitGiro", "status"], false);
    case SUBMIT_GIRO_SUCCESS:
      return state
        .setIn(["submitGiro", "loading"], false)
        .setIn(["submitGiro", "items"], action.data)
        .setIn(["submitGiro", "status"], true);
    case SUBMIT_GIRO_FAILURE:
      return state
        .setIn(["submitGiro", "loading"], false)
        .setIn(["submitGiro", "status"], false);
    case GET_GIRO_CALL_BACK_EXIST:
      return state
        .setIn(["getGIROCallBackExist", "loading"], true)
        .setIn(["getGIROCallBackExist", "status"], false);
    case GET_GIRO_CALL_BACK_EXIST_SUCCESS:
      return state
        .setIn(["getGIROCallBackExist", "loading"], false)
        .setIn(["getGIROCallBackExist", "items"], action.data)
        .setIn(["getGIROCallBackExist", "status"], true);
    case GET_GIRO_CALL_BACK_EXIST_FAILURE:
      return state
        .setIn(["getGIROCallBackExist", "loading"], false)
        .setIn(["getGIROCallBackExist", "status"], false);
    case GET_GIRO_SUBMIT_CALL_BACK_EXIST:
      return state
        .setIn(["getGIROSubmitCallBackExist", "loading"], true)
        .setIn(["getGIROSubmitCallBackExist", "status"], false);
    case GET_GIRO_SUBMIT_CALL_BACK_EXIST_SUCCESS:
      return state
        .setIn(["getGIROSubmitCallBackExist", "loading"], false)
        .setIn(["getGIROSubmitCallBackExist", "items"], action.data)
        .setIn(["getGIROSubmitCallBackExist", "status"], true);
    case GET_GIRO_SUBMIT_CALL_BACK_EXIST_FAILURE:
      return state
        .setIn(["getGIROSubmitCallBackExist", "loading"], false)
        .setIn(["getGIROSubmitCallBackExist", "status"], false);

        case ENROL_EGIRO:
      return state
        .setIn(["enroleGiro", "loading"], true)
        .setIn(["enroleGiro", "status"], false);
    case ENROL_EGIRO_SUCCESS:
      return state
        .setIn(["enroleGiro", "loading"], false)
        .setIn(["enroleGiro", "items"], action.data)
        .setIn(["enroleGiro", "status"], true);
    case ENROL_EGIRO_FAILURE:
      return state
        .setIn(["enroleGiro", "loading"], false)
        .setIn(["enroleGiro", "status"], false);

        case CONFIRM_PAY_EDDA_GI_RENEWAL:
          return state
            .setIn(["confirmPayEddaGiRenewal", "loading"], true)
            .setIn(["confirmPayEddaGiRenewal", "status"], false);
        case CONFIRM_PAY_EDDA_GI_RENEWAL_SUCCESS:
          return state
            .setIn(["confirmPayEddaGiRenewal", "loading"], false)
            .setIn(["confirmPayEddaGiRenewal", "items"], action.data)
            .setIn(["confirmPayEddaGiRenewal", "status"], true);
        case CONFIRM_PAY_EDDA_GI_RENEWAL_FAILURE:
          return state
            .setIn(["confirmPayEddaGiRenewal", "loading"], false)
            .setIn(["confirmPayEddaGiRenewal", "status"], false);

    default:
      return state;
  }
}

export default enrolGIRONow;
